<div class="p-panelmenu p-component">
    <div class="p-panelmenu-panel" *ngFor="let item of menuItens; let i=index">
        <div class="p-element p-component p-panelmenu-header">

            <div class="pointer p-panelmenu-header-link"
                [ngClass]="{'itemActive': item.expanded || item.active, 'expanded': item.expanded}" (click)="expand(i)"
                tabindex="0" [id]="item.id">
                <div>
                    <span *ngIf="item.icon" class="p-menuitem-icon {{item.icon}}"></span>
                    <span class="p-menuitem-text">{{item.label}}</span>
                </div>
                <span *ngIf="item.items && item.items.length > 0" class="p-panelmenu-icon pi pi-chevron-down"></span>
            </div>
        </div>

        <div class="p-toggleable-content collapse" navbar-collapse [ngbCollapse]="!item.expanded">
            <div role="region" class="p-panelmenu-content" id="undefined_content" aria-labelledby="undefined_header">
                <ul role="tree" class="p-submenu-list p-panelmenu-root-submenu">
                    <li *ngFor="let subItem of item.items; let j=index"
                        class="p-element p-menuitem {{subItem.active ? 'subItemActive' : ''}} pointer"
                        (click)="expand(i, j)">
                        <div role="treeitem" class="p-menuitem-link" target="undefined" tabindex="0">
                            <span *ngIf="subItem.icon" class="p-menuitem-icon {{subItem.icon}}"></span>
                            <span class="p-menuitem-text">{{subItem.label}}</span>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</div>